import axios from 'axios';
import { API_URL } from '../config';

export interface Plan {
  id: string;
  user_id: string;
  name: string;
  state: 'draft' | 'generated';
  dispatch_mode: string;
  email_text?: string;
  generated_json?: any;
  created_at: string;
  updated_at: string;
}

export interface PlansResponse {
  plans: Plan[];
  total: number;
  page: number;
  limit: number;
}

export interface CreatePlanPayload {
  name: string;
  state?: 'draft' | 'generated';
  dispatch_mode?: string;
  email_text?: string;
  generated_json?: any;
}

export interface UpdatePlanPayload {
  name?: string;
  state?: 'draft' | 'generated';
  dispatch_mode?: string;
  email_text?: string;
  generated_json?: any;
}

export const plansApi = {
  getPlans: async (
    getAuthHeaders: () => Record<string, string>,
    page: number = 1,
    limit: number = 10,
    state?: string,
    dispatch_mode?: string,
    search?: string
  ): Promise<PlansResponse> => {
    let url = `${API_URL}/api/plans?page=${page}&limit=${limit}`;
    if (state) url += `&state=${state}`;
    if (dispatch_mode) url += `&dispatch_mode=${dispatch_mode}`;
    if (search) url += `&search=${encodeURIComponent(search.trim())}`;

    const res = await axios.get(url, {
      headers: getAuthHeaders(),
      withCredentials: true,
    });
    return res.data;
  },

  getPlan: async (
    getAuthHeaders: () => Record<string, string>,
    id: string
  ): Promise<Plan> => {
    const res = await axios.get(`${API_URL}/api/plans/${id}`, {
      headers: getAuthHeaders(),
      withCredentials: true,
    });
    return res.data;
  },

  createPlan: async (
    getAuthHeaders: () => Record<string, string>,
    payload: CreatePlanPayload
  ): Promise<Plan> => {
    const res = await axios.post(`${API_URL}/api/plans`, payload, {
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      withCredentials: true,
    });
    return res.data;
  },

  updatePlan: async (
    getAuthHeaders: () => Record<string, string>,
    id: string,
    payload: UpdatePlanPayload
  ): Promise<Plan> => {
    const res = await axios.put(`${API_URL}/api/plans/${id}`, payload, {
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      withCredentials: true,
    });
    return res.data;
  }
};
